import axios from 'axios';
import axiosInstance from './AxiosService';

export const reviewNotesService = {
    // Get all review notes for a workpaper
    getReviewNotes: async (workpaperId) => {
        const response = await axiosInstance.get(`workpapers/${workpaperId}/review-notes/`);
        return response.data;
    },

    // Create a new review note
    createReviewNote: async (workpaperId, noteData) => {
        const response = await axiosInstance.post(`workpapers/${workpaperId}/review-notes/`, noteData);
        return response.data;
    },

    // Update a note's category
    updateNoteCategory: async (noteId, category) => {
        const response = await axiosInstance.patch(`review-notes/${noteId}/update_category/`, { category });
        return response.data;
    },

    // Toggle note resolved status
    toggleNoteResolved: async (noteId) => {
        const response = await axiosInstance.patch(`review-notes/${noteId}/toggle_resolved/`);
        return response.data;
    },

    // Delete a review note
    deleteReviewNote: async (noteId) => {
        await axiosInstance.delete(`review-notes/${noteId}/`);
    },

    // Update a note's text
    updateNoteText: async (noteId, text) => {
        const response = await axiosInstance.patch(`review-notes/${noteId}/update_note/`, { text });
        return response.data;
    }
}; 